module.exports = __webpack_public_path__ + "img/s2.62597f6a.png";